import React from 'react';
import { Link } from 'react-router-dom';
import { cartTotals, money, unitPrice } from '../../components/CartView/cartModel';

/* THE ORDER SUMMARY, GROUPED BY BRAND — ported from checkout.html's
   `summary()` (SP-main l.277-321), which is itself the same grouping cart.html
   and the add-to-cart drawer already use.
   ⚠ ONE OWNER FOR THE ARITHMETIC. This renders `cartModel.cartTotals()`
   directly rather than re-deriving anything, so checkout cannot disagree with
   the cart or the drawer about what a shopper is being charged — the exact
   class of bug §2.4 of this session's HANDOFF fixed once already (a
   per-vendor split that double-counted a store-level shipping rate). The old
   `OrderListing` component this replaces on the checkout route had its OWN
   second copy of this arithmetic, including a hardcoded `tax: 0` — the literal
   bug the rule below exists to prevent. It is intentionally not reused here.
   ⚠ UNITS, NOT LINES, for the "N items" line under a group — the reference
   names a real bug this caused: a parcel with one product at qty 2 read
   "1 item" because something counted cart lines instead of summing quantity. */
const units = (items) => (items || []).reduce((n, l) => n + (l.cart_quantity || 0), 0);

const CheckoutSummary = ({ cartItems }) => {
  const { subtotal, shipping, tax, total, groups } = cartTotals(cartItems);
  const taxKnown = tax !== null && tax !== undefined;

  return (
    <aside className="co-sum">
      <div className="co-sumin">
        <div className="co-sumhead">
          <h2>Order summary</h2>
          <Link to="/viewcart">Edit cart</Link>
        </div>

        {groups.length > 1 && (
          <p className="co-sumsplit">
            Arrives in {groups.length} parcels — each brand ships its own, so they may not turn up on the same day.
          </p>
        )}

        <div className="co-sumgroups">
          {groups.map((g) => (
            <div className="co-sumg" key={g.key}>
              <div className="co-sumghead">
                <div>
                  <span className="co-sumgname">Ships by {g.name}</span>
                  <span className="co-sumgmeta">
                    {units(g.items)} item{units(g.items) === 1 ? '' : 's'}
                    {g.eta ? ` · ${g.eta}` : ''}
                  </span>
                </div>
                <span className={`co-sumgship${g.isFree ? ' is-free' : ''}`}>{g.shipNote}</span>
              </div>
              {g.items.map((item, i) => {
                const img = item?.product_variants?.image
                  || item?.products?.product_images?.find((im) => im.is_main === '1')?.src
                  || item?.products?.product_images?.[0]?.src;
                const lineTotal = (item?.cart_quantity || 0) * unitPrice(item);
                return (
                  <div className="co-si" key={item.id ?? i}>
                    <span className="co-sithumb">
                      {img ? <img src={img} alt="" loading="lazy" /> : <span className="ph" />}
                      <i>{item.cart_quantity}</i>
                    </span>
                    <span className="co-sitext">
                      <span className="co-siname">{item?.products?.title}</span>
                    </span>
                    <span className="co-siprice">{money(lineTotal)}</span>
                  </div>
                );
              })}
            </div>
          ))}
        </div>

        <div className="co-sumtot">
          <div className="ct-srow"><span>Subtotal</span><span>{money(subtotal)}</span></div>
          <div className="ct-srow"><span>Shipping</span><span>{shipping ? money(shipping) : 'Free'}</span></div>
          <div className="ct-srow is-total">
            <span>{taxKnown ? 'Total' : 'Estimated total'}</span>
            <span>{money(total)}</span>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default CheckoutSummary;
